/** * 获取cookie * @param {String} key key */
export function getCookie (key) {
  let reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)')
  if (document.cookie.match(reg) && document.cookie.match(reg).length > 0) {
    let arr = document.cookie.match(reg)
    return (arr[2])
  } else {
    return null
  }
}

/** * 设置cookie * @param {String} key key * @param {String} value 值 * @param {Number} expireseconds 过期的秒数 */
export function setCookie (key, value, expireseconds) {
  var exdate = new Date()
  exdate.setDate(exdate.getSeconds() + expireseconds)
  document.cookie = key + '=' + escape(value) + ((expireseconds == null) ? '' : ';expires=' + exdate.toGMTString())
}

/** * 删除cookie * @param {String} name key */
export function delCookie (key) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(key)
  if (cval != null) document.cookie = key + '=' + cval + ';expires=' + exp.toGMTString()
}
